'use client';

import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    console.log('Toggling FAQ:', index);
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'Do I need to know anything about AI?',
      answer: 'No. We design and deliver everything for you — no tech skills required.',
    },
    {
      question: 'How much time can I realistically save?',
      answer: 'Most clients save between 10 and 40 hours per month within the first month.',
    },
    {
      question: 'What kinds of tasks can you automate?',
      answer:
        'Almost anything repetitive: admin, communication, reporting, or coordination between tools.',
    },
    {
      question: 'Can this work with my current tools?',
      answer:
        "Yes. We integrate with thousands of platforms — if it's online, we can connect to it. If you have API access, we can use it - but even if you don't, we can still connect.",
    },
    {
      question: 'Can you help entrepeneurs, small businesses as well as teams?',
      answer: 'Absolutely — we work with solo operators up to multi-location teams.',
    },
    {
      question: 'What happens after setup?',
      answer:
        'We provide ongoing optimisation and support to make sure your automations keep running smoothly.',
    },
  ];

  return (
    <section
      id="faq"
      className="faq"
      style={{ display: 'block', opacity: 1, visibility: 'visible' }}
    >
      <div className="faq-background">
        <div className="faq-background-overlay" />
      </div>
      <div className="container" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
        <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          Frequently Asked Questions
        </h2>

        <div className="faq-container" style={{ marginBottom: '0.5rem' }}>
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3>{faq.question}</h3>
                <div className="faq-toggle">{openIndex === index ? '−' : '+'}</div>
              </div>
              {openIndex === index && (
                <div className="faq-answer" style={{ display: 'block', padding: '1rem 2rem' }}>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
